module.exports = __webpack_public_path__ + "static/media/undraw_home_screen_re_640d.f7d3a9a1.svg";